import { motion } from "framer-motion";

const ease = [0.22, 1, 0.36, 1];

export const RevealLines = ({ lines, className = "", lineClass = "", delay = 0, inView = false }) => {
  const trigger = inView
    ? { whileInView: "show", viewport: { once: true, amount: 0.1 } }
    : { animate: "show" };
  return (
    <motion.span className={`block ${className}`} initial="hide" {...trigger}>
      {lines.map((line, i) => (
        <span key={i} className="block overflow-hidden pb-[0.08em]">
          <motion.span
            className={`block ${lineClass}`}
            variants={{ hide: { y: "105%" }, show: { y: "0%" } }}
            transition={{ duration: 1.1, delay: delay + i * 0.12, ease }}
          >
            {line}
          </motion.span>
        </span>
      ))}
    </motion.span>
  );
};

export const FadeUp = ({ children, delay = 0, className = "" }) => (
  <motion.div className={className} initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.1 }} transition={{ duration: 0.9, delay, ease }}>
    {children}
  </motion.div>
);
